export default __webpack_public_path__ + "3fccf160731d723c5f7171bce91f2442.png";